//swiper
class Sliders {
    plugins: Array<any> = [];
    swipers: NodeListOf<HTMLElement>;
    activeSwipers: Array<any> = [];

    constructor(plugins: Array<any>) {
        this.plugins = plugins;
        this.init();
    }

    init() {
        let self = this;
        this.swipers = document.querySelectorAll('.swiper');
        this.swipers.forEach(function (swiper) {
            // if (!swiper.id) {
            //     swiper.id = crypto["randomUUID"]();
            // }
            let type = swiper.dataset.type;
            var plugin = self.plugins.find(plugins => plugins.type === type)
            if (plugin) {
                self.activeSwipers.push(new plugin(swiper));
            }
        });
    }
}
export default Sliders;